<app-maintenance-mode-alert></app-maintenance-mode-alert>
<app-location-context-panel></app-location-context-panel>

<div class="content">
    <app-maintenance-test-commands></app-maintenance-test-commands>
</div>